export default __webpack_public_path__ + "static/media/tile_of_decarabians_tower.eecad058.png";